module.exports = __webpack_public_path__ + "static/media/pots.43280d1c.JPG";